import { faEnvelope, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Button from '../../Shared/Form/Button';
import Form from '../../Shared/Form/Form';
import Input from '../../Shared/Form/Input';
import Title from '../../Shared/Title';
import SidePanelWrapper from './../SidePanelWrapper';
import { Strings } from "../../../Strings/nl";
import DigipasLogoWidePNG from "../../../Assets/digipaslogowide.png";
import { useForgotPasswordMutation } from "../../../Redux/Api/Auth";
import { useAppSelector } from "../../../Redux/store";
import { Hydra } from "../../../Utils/Hydra";
import StatusPopups from "../../Shared/Form/StatusPopups";
import BusyArea from "../../Shared/BusyArea";
import LanguageDropdown from '../../Shared/LanguageDropdown';
import { useTranslation } from "react-i18next";
import IconSVG from '../../../Assets/icon.svg?component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const logoutError = useAppSelector((s) => s.auth.logoutReason);

    const [forgotPassword, setForgotPassword] = useForgotPasswordMutation();
    const [error, setError] = useState<string | undefined>(logoutError);
    const [submitted, setSubmitted] = useState(false);
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        const pathSegments = window.location.pathname.split('/');
        const currentLang = pathSegments[1].toLowerCase();
        const validLanguages = ['nl', 'en', 'de', 'fr', 'es'];

        if (validLanguages.includes(currentLang)) {
            i18n.changeLanguage(currentLang).then(() => {
            });
        }
    }, [i18n]);

    const submit = async (data: { email: string; language: string }) => {
        if (busy) return;

        setSubmitted(true);
        setBusy(true);
        setSuccessMessage('');
        setError('');

        const requestData = {
            email: data.email,
            language: i18n.language
        };

        try {
            await forgotPassword(requestData).unwrap();
            setSuccessMessage(t("forgotPassword:mailSend") + data.email);
        } catch (e) {
            setError(t("forgotPassword:error") || "");
        }
        setBusy(false);
    };

    return (
        <>
            <SidePanelWrapper style={{ position: 'relative', display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '100vh', backgroundColor: 'white' }}>
                <StatusPopups setText={setSuccessMessage} type='success' text={successMessage} />
                <StatusPopups setText={setError} type='error' text={error === "noRightsToThisAction" ? undefined : error} />
                <Title center text={t("forgotPassword:forgotPassword")} subtitle={t("forgotPassword:forgotPasswordPrefix") || ""} />
                <BusyArea busy={busy}>
                    <div className='flex justify-between items-center absolute top-0 left-0 p-5 w-full'>
                        <div className='text-brand flex items-center gap-2 font-bold'><IconSVG className='w-10 h-10' /><span className='text-2xl ml-1 font-app'>D I G I P A S</span></div>
                        <LanguageDropdown />
                    </div>
                    <Form submit={submit}>
                        <Input autoComplete submitted={submitted ? true : false} label={t("forgotPassword:email")} id='email' />
                        <div className="flex w-full mb-4">
                            <Button title={t('forgotPassword:reset')} icon={busy ? faSpinner : faEnvelope} className="flex-1 py-2 " />
                        </div>
                        <div className="flex mt-10">
                            <Link to={`/${i18n.language}/login`} style={{ fontSize: '16px' }} className="w-full text-center no-underline hover:underline flex items-center justify-center">
                                <FontAwesomeIcon icon={faArrowLeft} className='mr-2 h-3.5' />{t('forgotPassword:back')}
                            </Link>
                        </div>
                    </Form>
                </BusyArea>
            </SidePanelWrapper>
        </>
    );
};

export default ForgotPasswordPage;
